import React from "react";
import { Col, Row } from "antd";
import { NewsCard } from "./NewsCard";
import _ from "lodash";
import "./index.scss";

import new1ImageSrc from "./images/最新活动配图1.png";
import new2ImageSrc from "./images/最新活动配图2.png";

import { HomePageLayout } from "../HomePageLayout";
import { Link } from "react-router-dom";
import { prefix } from "../../../config";

const newItems: ReadonlyArray<{
  imageSrc: string;
  description: string;
  id: string;
}> = [
  {
    imageSrc: new1ImageSrc,
    description: "独行快，众行远｜依图携手战略合作伙伴，共同开创大模型新时代！",
    id: "1"
  },
  {
    imageSrc: new2ImageSrc,
    description: "志合越山海，聚力共前行｜依图多模态大模型伙伴CTO精研班圆满举办",
    id: "2"
  }
];

export const DetailNewsList = () => {
  return (
    <Row gutter={[16, 16]}>
      {_.map(newItems, (props, idx) => (
        <Col xs={24} md={24}>
          <Link to={`${prefix}/news/${props.id}`}>
            <NewsCard {...props} />
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export const NewsList = () => {
  return (
    <Row gutter={[16, 0]}>
      {_.map(newItems, (props, idx) => (
        <Col xs={24} md={12} key={idx}>
          <Row justify="center" type="flex">
            <Col xs={24} md={24}>
              <Link to={`${prefix}/news/${props.id}`}>
                <NewsCard {...props} />
              </Link>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  );
};

export const NewsWall = () => {
  return (
    <HomePageLayout title="最新活动" anchor="activity">
      <NewsList />
    </HomePageLayout>
  );
};
